export default __webpack_public_path__ + "static/media/shadower.ae5e3ce0.png";